export default __webpack_public_path__ + "static/Live-Video_AVG-7833a5cee40ee7df6963b9ecf8210a46.webp";